import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/Logotype.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-5c0e7fd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "menuItem logo"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  title: "Home"
}, null, -1))
const _hoisted_3 = { class: "selInd" }
const _hoisted_4 = { key: 0 }

import { debounce } from 'lodash-es';
import {
  computed,
  ComputedRef,
  defineAsyncComponent,
  nextTick,
  onBeforeUnmount,
  onMounted,
  Ref,
  ref,
  watch,
} from 'vue';

import BrandIcon from '@/components/icons/BrandIcon.vue';
import { useRoute } from '@/composables/router/VueRouter';
import { AppPattern } from '@/data/Branding';
import BrowserDetection from '@/data/BrowserDetection';
import { patternForApp } from '@/data/helpers/TaskHelper';
import { MiniApp } from '@/data/tasks/MiniApp';
import RouteNames from '@/router/RouteNames';
import { useTasksStore } from '@/stores/Tasks';
import { useTrackEntriesStore } from '@/stores/TrackEntries';
import { useTracksStore } from '@/stores/Tracks';
import { useUIStateStore } from '@/stores/UIState';

interface Props {
  // This one is required for mobile, as we show some icons in footer too
  isHeader?: boolean;
}
interface Emits {
  (e: 'clearAllNotifications'): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PrimaryMenu',
  props: {
    isHeader: { type: Boolean, default: true }
  },
  emits: ["clearAllNotifications"],
  setup(__props: any) {

const NonAppMenu = defineAsyncComponent(() => import('@/NonAppMenu.vue'));

const tracksStore = useTracksStore();
const trackEntriesStore = useTrackEntriesStore();

const tasksStore = useTasksStore();
const uiStateStore = useUIStateStore();

const route = useRoute();

const props = __props;



const itemsHolder: Ref<HTMLDivElement | null> = ref(null);
const homeItem: Ref<HTMLDivElement | null> = ref(null);

const routeName: Ref<string> = ref('');

// TODO: on first render grab the home icon width
const itemWidth: Ref<number> = ref(69);
const maxWidth: Ref<number> = ref(0);
const itemWidthAttempt: Ref<number> = ref(0);

const menuWidthResizeObserver: Ref<ResizeObserver | null> = ref(null);

const debouncedHandleResize = debounce(handleResize, 20, {
  maxWait: 50,
  leading: true,
  trailing: true,
});

const activeAppId: ComputedRef<string | undefined> = computed(() => {
  return tracksStore.activeAppId;
});

const showMenuToggle: ComputedRef<boolean> = computed(() => {
  return ![
    '',
    RouteNames.HOME_ROUTE_NAME,
    RouteNames.PROFILE_SETTINGS_ROUTE_NAME,
    RouteNames.TASKS_ROUTE_NAME,
    RouteNames.NOTIFICATIONS_ROUTE_NAME,
    RouteNames.ICONS_ROUTE_NAME,
    RouteNames.COMPONENTS_ROUTE_NAME,
    RouteNames.TASKS_TABLE_ROUTE_NAME,
    RouteNames.APP_TABLE_ROUTE_NAME,
    RouteNames.APP_ROUTE_NAME,
    RouteNames.REPORTING_ROUTE_NAME,
    RouteNames.REPORTING_TENANT_ROUTE_NAME,
  ].includes(routeName.value);
});

const patternByApp: ComputedRef<Record<string, AppPattern>> = computed(() => {
  const patternByApp: Record<string, AppPattern> = {};
  tasksStore.tenantAppsVisibleToUser.forEach((app: MiniApp) => {
    patternByApp[app.id] = patternForApp(app);
  });
  return patternByApp;
});

const activeAppPattern: ComputedRef<AppPattern | undefined> = computed(() => {
  if (!activeAppId.value) {
    return;
  }
  return patternByApp.value[activeAppId.value];
});

const isHomeRoot: ComputedRef<boolean> = computed(() => {
  return route.name === RouteNames.HOME_ROUTE_NAME;
});

const isMobile: ComputedRef<boolean> = computed(() => {
  return BrowserDetection.isMobile();
});

const isMenuItemVisible: ComputedRef<boolean> = computed(() => {
  return (isMobile.value !== props.isHeader);
});

function toggleMobileSideMenu(): void {
  uiStateStore.toggleMobileSideMenuOpen();
  if (routeName.value !== RouteNames.KNOWLEDGE_MANAGEMENT_ROUTE_NAME) {
    if (trackEntriesStore.currentlyDisplayedFile) {
      trackEntriesStore.setCurrentlyDisplayedFile(null);
    }
  }
}

function handleResize(): void {
  // By requesting an animation frame as well as debouncing, we handle the edges where one debounce ends due to
  // the maxWait and the next starts
  requestAnimationFrame(() => {
    intHandleResize();
  });
}

function intHandleResize(): void {
  maxWidth.value = itemsHolder.value?.clientWidth ?? 0;
}

function updateItemWidth(): void {
  if (++itemWidthAttempt.value >= 20) {
    return;
  }
  nextTick(() => {
    const width: number = homeItem.value?.offsetWidth ?? 0;
    if (!width) {
      setTimeout(updateItemWidth, 100);
      return;
    }
    itemWidth.value = width;
  });
}

watch(() => route.name, (newValue: string) => {
  // Set via a watcher as it wasn't reliably recalculating when using directly in a getter
  routeName.value = newValue;
}, { immediate: true });

onMounted(() => {
  if (!isMobile.value) {
    nextTick(() => {
      menuWidthResizeObserver.value = new ResizeObserver(debouncedHandleResize);
      if (itemsHolder.value) {
        menuWidthResizeObserver.value.observe(itemsHolder.value);
      }
    });
    updateItemWidth();
  }
});

onBeforeUnmount(() => {
  menuWidthResizeObserver.value?.disconnect();
  menuWidthResizeObserver.value = null;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    id: "primaryMenu",
    class: _normalizeClass({isMobile: isMobile.value})
  }, [
    (!isMobile.value || (_ctx.isHeader && !showMenuToggle.value))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_router_link, {
            "aria-label": "Home",
            to: { name: 'Home' },
            class: "root",
            tabindex: -1
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ], undefined, true),
            _: 1
          })
        ]))
      : (_ctx.isHeader && isMobile.value && showMenuToggle.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["menuItem navToggle", { appStyle: activeAppId.value}]),
            style: _normalizeStyle(activeAppId.value && activeAppPattern.value ? { background: activeAppPattern.value.gradient} : undefined)
          }, [
            _createElementVNode("button", {
              "aria-label": "Menu",
              onClick: toggleMobileSideMenu
            }, [
              _createVNode(BrandIcon, {
                name: "compact/burger-menu-compact",
                title: "Menu"
              })
            ])
          ], 6))
        : _createCommentVNode("", true),
    (isMenuItemVisible.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", {
            class: "menuItem home",
            ref_key: "homeItem",
            ref: homeItem
          }, [
            _createVNode(_component_router_link, {
              "aria-label": "Home",
              to: { name: 'Home' },
              class: "logo",
              title: "Home"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _withDirectives(_createVNode(BrandIcon, {
                    name: "flat/home-solid",
                    showFocus: false
                  }, null, 512), [
                    [_vShow, isHomeRoot.value]
                  ]),
                  _withDirectives(_createVNode(BrandIcon, {
                    name: "flat/home-light",
                    showFocus: false
                  }, null, 512), [
                    [_vShow, !isHomeRoot.value]
                  ])
                ])
              ], undefined, true),
              _: 1
            })
          ], 512),
          (isMobile.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_unref(NonAppMenu), {
                  onClearAllNotifications: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clearAllNotifications'))),
                  isHeader: _ctx.isHeader
                }, null, 8, ["isHeader"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}
}

})